// DO NOT set the `name` and `ticker` properties manually
// Instead use one of the get token metadata scripts https://github.com/ExodusMovement/exodus-core/tree/master/packages/assets-base#get-token-metadata

export default [
  {
    name: 'aave',
    displayName: 'Aave',
    decimals: 18,
    ticker: 'AAVE',
    addresses: { current: '0x7fc66500c84a76ad7e9c93437bfc5ac33e2ddae9' },
    primaryColor: '#9391F7',
    gradientColors: ['#9391F7', '#B2B1FF'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '20%', y2: '20%' },
  },
  {
    name: 'ach_ethereum_fbad19a6',
    displayName: 'Alchemy Pay',
    displayTicker: 'ACH',
    ticker: 'ACHethereumFBAD19A6',
    decimals: 8,
    addresses: { current: '0xed04915c23f00a313a544955524eb7dbd823143d' },
    info: {
      description:
        'ACH is the utility token that powers Alchemy Pay, a payments platform that supports transactions with a wide variety of fiat and cryptocurrencies. It connects developers, sellers, and organizations to Web3 in many ways, such as allowing payments to be made in crypto but received in fiat.',
      reddit: 'https://reddit.com/r/AlchemyPay/',
      twitter: 'https://twitter.com/AlchemyPay',
      website: 'https://alchemypay.org/',
    },
    primaryColor: '#4471ED',
    gradientColors: ['#0D48EA', '#4471ED'],
    gradientCoords: { x1: '86.792%', y1: '19.043%', x2: '12.879%', y2: '81.232%' },
  },
  {
    name: 'airswap',
    displayName: 'AirSwap',
    decimals: 4,
    ticker: 'AST',
    addresses: { current: '0x27054b13b1B798B345b591a4d22e6562d47eA75a' },
    info: {
      description:
        'AirSwap aims to empower truly decentralized finance with its peer-to-peer trading network for Ethereum tokens, which is easy to use, available on all devices and in numerous languages, and free of any fees.',
      reddit: 'https://www.reddit.com/r/AirSwap/',
      twitter: 'https://twitter.com/airswap',
      website: 'https://www.airswap.io/',
      telegram: 'https://t.me/airswap',
    },
    primaryColor: '#00A2FF',
    gradientColors: ['#00A2FF', '#002AFF'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '102%', y2: '101%' },
  },
  {
    name: 'ali_ethereum_9ae8d1eb',
    displayName: 'Artificial Liquid Intelligence',
    decimals: 18,
    ticker: 'ALIethereum9AE8D1EB',
    displayTicker: 'ALI',
    addresses: { current: '0x6b0b3a982b4634ac68dd83a4dbf02311ce324181' },
    info: {
      description:
        'ALI token is the utility token of the AI Protocol and the decentralized applications built on it. It enables the creation and upgrades of iNFTs, access to AI systems, governance, and transactions within the AI protocol.',
      reddit: 'https://reddit.com/r/Alethea',
      twitter: 'https://twitter.com/real_alethea',
      website: 'https://alethea.ai/',
    },
    primaryColor: '#29ABE2',
    gradientColors: ['#29ABE2', '#77D7FF'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '100%', y2: '100%' },
  },
  {
    name: 'alchemix',
    displayName: 'Alchemix',
    decimals: 18,
    ticker: 'ALCX',
    addresses: { current: '0xdbdb4d16eda451d0503b854cf79d55697f90c8df' },
    info: {
      description:
        'Alchemix is the governance token for Alchemix Finance, an Ethereum-based DeFi platform offering loans that the lenders pay off automatically using their collateral yield.',
      reddit: '',
      twitter: 'https://twitter.com/alchemixfi',
      website: 'https://alchemix.fi/',
    },
    primaryColor: '#F5C099',
    gradientColors: ['#B98863', '#F5C099'],
    gradientCoords: { x1: '10.5%', y1: '3.5%', x2: '38.5%', y2: '53.5%' },
  },
  {
    name: 'amp',
    displayName: 'Amp',
    decimals: 18,
    ticker: 'AMP',
    addresses: { current: '0xfF20817765cB7f73d4bde2e66e067E58D11095C2' },
    info: {
      description:
        'AMP are tokens used as collateral for payments in other cryptocurrencies made on the Flexa network. AMP can be sold to cover losses due to over-long transaction times or failures in transaction confirmation.',
      reddit: 'https://www.reddit.com/r/AMPToken/',
      twitter: 'https://twitter.com/amptoken',
      website: 'https://amptoken.org/',
    },
    primaryColor: '#D9327C',
    gradientColors: ['#FF6FBB', '#D9327C'],
    gradientCoords: { x1: '100%', y1: '100%', x2: '0%', y2: '0%' },
  },
  {
    name: 'ankr',
    displayName: 'Ankr Network',
    decimals: 18,
    ticker: 'ANKR',
    addresses: { current: '0x8290333cef9e6d528dd5618fb97a76f268f3edd4' },
    info: {
      description:
        'ANKR is the currency powering the Ankr platform that provides tools to facilitate use of Web3, increasing the efficiency of blockchain ecosystems.',
      twitter: 'https://twitter.com/ankr',
      website: 'https://www.ankr.com/',
      telegram: 'https://t.me/ankrnetwork',
    },
    primaryColor: '#396FF9',
    gradientColors: ['#0B39B0', '#396FF9'],
    gradientCoords: { x1: '119.625%', y1: '113.067%', x2: '0%', y2: '0%' },
  },
  {
    name: 'ape',
    displayName: 'ApeCoin',
    decimals: 18,
    ticker: 'APE',
    addresses: { current: '0x4d224452801ACEd8B2F0aebE155379bb5D594381' },
    info: {
      description:
        'ApeCoin is an Ethereum-based token that powers the Bored Ape Yacht Club ecosystem. It offers governance for the ApeCoin DAO, the governing body composed of all APE holders.',
      twitter: 'https://twitter.com/apecoin',
      website: 'https://apecoin.com/',
      telegram: 'https://t.me/APE_Token',
    },
    primaryColor: '#3274F5',
    gradientColors: ['#024AD7', '#3274F5'],
    gradientCoords: { x1: '-5%', y1: '1%', x2: '48.253%', y2: '30.034%' },
  },
  {
    name: 'api3',
    displayName: 'API3',
    decimals: 18,
    ticker: 'API3',
    addresses: { current: '0x0b38210ea11411557c13457D4dA7dC6ea731B88a' },
    info: {
      description:
        'APIs bring off-chain information to the blockchain, and API3 empowers this process by offering smart contracts that can connect, manage, monetize, and scale decentralized APIs on the blockchain.',
      reddit: 'https://reddit.com/r/API3',
      twitter: 'https://twitter.com/API3DAO',
      website: 'https://api3.org/',
      telegram: 'https://t.me/API3DAO',
    },
    primaryColor: '#7CE3CB',
    gradientColors: ['#5BAB98', '#7CE3CB'],
    gradientCoords: { x1: '3%', y1: '4%', x2: '36%', y2: '35.5%' },
  },
  {
    name: 'aragonv2',
    displayName: 'Aragon',
    decimals: 18,
    ticker: 'ANT',
    addresses: { current: '0xa117000000f279D81A1D3cc75430fAA017FA5A2e' },
    info: {
      description:
        'Aragon is an Ethereum-based answer to bureaucracy that allows individuals to form organizations like companies, non-profits, and more, across borders, without intermediaries, and free from censorship or oppression.',
      reddit: 'https://www.reddit.com/r/aragonproject/',
      twitter: 'https://twitter.com/aragonproject',
      website: 'https://aragon.org/',
    },
    primaryColor: '#0EE7F7',
    gradientColors: ['#01E8F7', '#00C2FF'],
    gradientCoords: { x1: '50.108%', y1: '28.284%', x2: '53.524%', y2: '115.891%' },
  },
  {
    name: 'audius',
    displayName: 'Audius',
    decimals: 18,
    ticker: 'AUDIO',
    addresses: { current: '0x18aAA7115705e8be94bfFEBDE57Af9BFc265B998' },
    info: {
      description:
        'Audius is a decentralized streaming community for musicians to get discovered, grow, and earn money.',
      reddit: 'https://reddit.com/r/audius',
      twitter: 'https://twitter.com/AudiusProject',
      website: 'https://audius.co',
      telegram: 'https://t.me/Audius',
    },
    primaryColor: '#ED43FF',
    gradientColors: ['#CC0FE0', '#7E1BCC'],
    gradientCoords: { x1: '44.5%', y1: '40%', x2: '-4.548%', y2: '4.017%' },
  },
  {
    name: 'axieinfinity',
    displayName: 'Axie Infinity',
    decimals: 18,
    ticker: 'AXS',
    addresses: { current: '0xBB0E17EF65F82Ab018d8EDd776e8DD940327B28b' },
    info: {
      description:
        'Axie Infinity is a game where players raise NFT-based creatures called Axies and battle them against other players. Players earn tokens so they partially own and operate the game.',
      reddit: 'https://reddit.com/r/AxieInfinity',
      twitter: 'https://twitter.com/AxieInfinity',
      website: 'https://axieinfinity.com/',
      telegram: 'https://t.me/axieinfinity',
    },
    primaryColor: '#0055D5',
    gradientColors: ['#0045AD', '#0055D5'],
    gradientCoords: { x1: '63.701%', y1: '21.261%', x2: '17.913%', y2: '-17.415%' },
  },
  {
    name: 'balancer',
    displayName: 'Balancer',
    decimals: 18,
    ticker: 'BAL',
    addresses: { current: '0xba100000625a3754423978a60c9317c58a424e3D' },
    info: {
      description:
        'BAL is the governance token of the Balancer protocol, a platform that allows users to harness the power of Automated Market Makers to combine trading and custody of funds and improve on both using Ethereum.',
      twitter: 'https://twitter.com/balancerlabs',
      website: 'https://balancer.finance/',
    },
    primaryColor: '#536DF9',
    gradientColors: ['#536DF9', '#3957F9'],
    gradientCoords: { x1: '0%', y1: '21.958%', x2: '99.612%', y2: '78.958%' },
  },
  {
    name: 'bancor',
    displayName: 'Bancor',
    decimals: 18,
    ticker: 'BNT',
    addresses: { current: '0x1F573D6Fb3F13d689FF844B4cE37794d79a7FF1C' },
    info: {
      description:
        'Bancor wants to enable the conversion of any token to another without having to match buyers and sellers like an exchange. Users won’t be stuck with tokens that are hard to sell, as they will be able to convert them into any of the assets supported by Bancor’s network.',
      reddit: 'https://www.reddit.com/r/Bancor/',
      twitter: 'https://twitter.com/Bancor',
      website: 'https://www.bancor.network/',
      telegram: 'https://t.me/bancor',
    },
    primaryColor: '#3464A5',
    gradientColors: ['#3464A5', '#22416B'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '102%', y2: '101%' },
  },
  {
    name: 'band_ethereum_a9ddc2a2',
    displayName: 'Band Protocol',
    decimals: 18,
    ticker: 'BANDethereumA9DDC2A2',
    displayTicker: 'BAND',
    addresses: { current: '0xBA11D00c5f74255f56a5E366F4F77f5A186d7f55' },
    info: {
      description:
        'Band Protocol brings data and APIs to the blockchain to offer oracle solutions that make it easier to create Web3 products. It provides fast transactions, scalability, and data flexibility.',
      reddit: 'https://reddit.com/r/bandprotocol',
      twitter: 'https://twitter.com/bandprotocol',
      website: 'https://bandprotocol.com/',
      telegram: 'https://t.me/bandprotocol',
    },
    primaryColor: '#562FFF',
    gradientColors: ['#562FFF', '#A08AFF'],
    gradientCoords: { x1: '3%', y1: '8.4%', x2: '41.04%', y2: '26.7%' },
  },
  {
    name: 'bat',
    displayName: 'Basic Attention Token',
    decimals: 18,
    ticker: 'BAT',
    addresses: { current: '0x0D8775F648430679A709E98d2b0Cb6250d2887EF' },
    info: {
      description:
        'Basic Attention Token is an Ethereum-based token from the creator of Javascript and co-founder of Mozilla and Firefox that seeks to revolutionize web browsing by allowing advertisers and publishers to earn more while paying users to browse the Web.',
      reddit: 'https://www.reddit.com/r/BATProject/',
      twitter: 'https://twitter.com/AttentionToken',
      website: 'https://basicattentiontoken.org/',
      telegram: 'https://t.me/batproject',
    },
    primaryColor: '#FF3B00',
    gradientColors: ['#FF3B00', '#9F2B65'],
    gradientCoords: { x1: '22.351%', y1: '-12.223%', x2: '98.837%', y2: '152.777%' },
  },
  {
    name: 'blur_ethereum_ef097961',
    displayName: 'Blur',
    decimals: 18,
    ticker: 'BLURethereumEF097961',
    displayTicker: 'BLUR',
    addresses: {
      current: '0x5283D291DBCF85356A21bA090E6db59121208b44',
    },
    info: {
      description:
        'BLUR is the governance token of Blur, a non-custodial NFT marketplace and marketplace aggregator. Users can buy NFTs from multiple marketplaces directly through Blur at blazing fast speeds.',
      twitter: 'https://twitter.com/blur_io',
      website: 'https://blur.io/',
    },
    primaryColor: '#FF8700',
    gradientColors: ['#FF8700', '#FFAD33'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '100%', y2: '100%' },
  },
  {
    name: 'bone_ethereum_1cdd7eb5',
    displayName: 'Bone ShibaSwap',
    decimals: 18,
    ticker: 'BONEethereum1CDD7EB5',
    displayTicker: 'BONE',
    addresses: { current: '0x9813037ee2218799597d83d4a5b6f3b6778218d9' },
    info: {
      description:
        'BONE is the governance token of ShibaSwap, a DeFi platform and DEX of the Shiba Inu ecosystem. Additionally, BONE is a reward token provided to liquidity providers on ShibaSwap.',
      twitter: 'https://twitter.com/shibtoken',
      website: 'https://shibaswap.com',
    },
    primaryColor: '#FFA409',
    gradientColors: ['#FF4D00', '#FFA409'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '100%', y2: '100%' },
  },
  {
    name: 'busd',
    displayName: 'Binance USD',
    decimals: 18,
    ticker: 'BUSD',
    addresses: { current: '0x4Fabb145d64652a948d72533023f6E7A623C7C53' },
    info: {
      description:
        'Stablecoin, issued in partnership with Binance. BUSD is 100% backed by U.S. dollars held in FDIC-insured U.S. banks.',
      twitter: 'https://twitter.com/paxosglobal',
      website: 'https://www.paxos.com/busd/',
    },
    primaryColor: '#FFC200',
    gradientColors: ['#FFC200', '#CC9B00'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '102%', y2: '101%' },
  },
  {
    name: 'cbeth_ethereum_32621dca',
    displayName: 'Coinbase Wrapped Staked ETH',
    decimals: 18,
    ticker: 'CBETHethereum32621DCA',
    displayTicker: 'CBETH',
    addresses: { current: '0xbe9895146f7af43049ca1c1ae358b0541ea49704' },
    info: {
      description:
        'CBETH is a token that represents ETH staked on Coinbase. It makes it possible for users to sell, trade, and move their staked ETH while it’s locked during the network upgrade to ETH 2.0.',
      twitter: 'https://twitter.com/CoinbaseAssets',
      website: 'https://www.coinbase.com/price/coinbase-wrapped-staked-eth',
    },
    primaryColor: '#0052FF',
    gradientColors: ['#0052FF', '#3E7CFF'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '100%', y2: '100%' },
  },
  {
    name: 'chainlink',
    displayName: 'Chainlink',
    decimals: 18,
    ticker: 'LINK',
    addresses: { current: '0x514910771AF9Ca656af840dff83E8264EcF986CA' },
    info: {
      description:
        'Blockchain-based smart contracts currently can’t connect to the outside world in a decentralized way. Using a network of decentralized data oracles, Chainlink aims to connect smart contracts to real-world data and payment systems.',
      reddit: 'https://www.reddit.com/r/Chainlink/',
      twitter: 'https://twitter.com/chainlink',
      website: 'https://chain.link/',
      telegram: 'https://t.me/chainlinkofficial',
    },
    primaryColor: '#3FA0F1',
    gradientColors: ['#3FA0F1', '#295ADA'],
    gradientCoords: { x1: '-22.982%', y1: '-43.915%', x2: '91.53%', y2: '101%' },
  },
  {
    name: 'chiliz',
    displayName: 'Chiliz',
    decimals: 18,
    ticker: 'CHZ',
    addresses: { current: '0x3506424f91fd33084466f402d5d97f05f8e3b4af' },
    info: {
      description:
        'The exclusive currency of the Chiliz blockchain infrastructure, $CHZ is used in sports and entertainment on the Socios.com platform.',
      twitter: 'https://twitter.com/chiliz',
      website: 'https://www.chiliz.com/',
      telegram: 'https://t.me/chiliz_io',
    },
    primaryColor: '#F82965',
    gradientColors: ['#A31A41', '#F82965'],
    gradientCoords: { x1: '119.625%', y1: '113.067%', x2: '0%', y2: '0%' },
  },
  {
    name: 'civic',
    displayName: 'Civic',
    decimals: 8,
    ticker: 'CVC',
    addresses: { current: '0x41e5560054824eA6B0732E656E3Ad64E20e94E45' },
    info: {
      description:
        'Civic is an Ethereum-based token that allows users to store encrypted confirmations of their identity by third parties. These credentials can only be accessed with the user’s biometrics (face, touch, etc.) and are stored on the blockchain instead of a centralized server. Civic believes it will eliminate identity theft and fraud as well as logins with usernames and passwords.',
      reddit: 'https://www.reddit.com/r/civicplatform/',
      twitter: 'https://twitter.com/civickey',
      website: 'https://www.civic.com/',
      telegram: 'https://t.me/civicplatform',
    },
    primaryColor: '#06DA30',
    gradientColors: ['#06DA30', '#00B424'],
    gradientCoords: { x1: '22.351%', y1: '-12.223%', x2: '98.837%', y2: '152.777%' },
  },
  {
    name: 'compound',
    displayName: 'Compound',
    decimals: 18,
    ticker: 'COMP',
    addresses: { current: '0xc00e94Cb662C3520282E6f5717214004A7f26888' },
    info: {
      description:
        'Compound is an ERC-20 asset that empowers community governance of the Compound protocol. COMP token-holders and their delegates debate, propose, and vote on all changes to the protocol.',
      twitter: 'https://twitter.com/compoundfinance',
      website: 'https://compound.finance/',
    },
    primaryColor: '#00D395',
    gradientColors: ['#00D395', '#00A171'],
    gradientCoords: { x1: '91.53%', y1: '101%', x2: '10.484%', y2: '0.517%' },
  },
  {
    name: 'coti',
    displayName: 'COTI',
    decimals: 18,
    ticker: 'COTI',
    addresses: { current: '0xDDB3422497E61e13543BeA06989C0789117555c5' },
    info: {
      description:
        'Coti allows merchants, governments, dApps, and other organizations to create unique payment systems and digital currencies with the benefits of low fees, short processing times, and increased global reach.',
      reddit: 'https://reddit.com/r/cotinetwork',
      twitter: 'https://twitter.com/COTInetwork',
      website: 'https://coti.io/',
      telegram: 'https://t.me/COTInetwork',
    },
    primaryColor: '#28ACD7',
    gradientColors: ['#1B58B3', '#28ACD7'],
    gradientCoords: { x1: '3%', y1: '4%', x2: '36%', y2: '35.5%' },
  },
  {
    name: 'cro',
    displayName: 'Cronos',
    decimals: 8,
    ticker: 'CRO',
    addresses: { current: '0xA0b73E1Ff0B80914AB6fe0444E65848C4C34450b' },
    info: {
      description:
        'CRO is an Ethereum-based token (ERC20) that powers the overall Crypto.com ecosystem, with utility across payment, trading, and financial services. Other versions of the token run on the Crypto.org and Cronos chains.',
      reddit: 'https://www.reddit.com/r/Crypto_com/',
      twitter: 'https://twitter.com/cryptocom',
      website: 'https://chain.crypto.com/',
      telegram: 'https://t.me/CryptoComOfficial',
    },
    primaryColor: '#1E73B8',
    gradientColors: ['#1E73B8', '#134A76'],
    gradientCoords: { x1: '-10.499%', y1: '0%', x2: '102%', y2: '101%' },
  },
  {
    name: 'crv',
    displayName: 'Curve DAO',
    decimals: 18,
    ticker: 'CRV',
    addresses: { current: '0xD533a949740bb3306d119CC777fa900bA034cd52' },
    info: {
      description:
        'CRV is the governance token of Curve, a decentralized protocol for automated liquidity that uses complex algorithms to incentivize users by offering higher returns and minimal fees.',
      twitter: 'https://twitter.com/curvefinance',
      website: 'https://www.curve.fi/',
      telegram: 'https://t.me/curvefi',
    },
    primaryColor: '#2CFFCA',
    gradientColors: ['#1C66A5', '#2CFFCA'],
    gradientCoords: { x1: '0%', y1: '21.958%', x2: '99.612%', y2: '78.958%' },
  },
  {
    name: 'cvx',
    displayName: 'Convex Finance',
    decimals: 18,
    ticker: 'CVX',
    addresses: { current: '0x4e3FBD56CD56c3e72c1403e103b45Db9da5B9D2B' },
    info: {
      description:
        'Convex Finance is a protocol that maximizes staking rewards for CRV holders and liquidity providers. By providing liquidity to a CRV liquidity pool supported by CVX, users receive multiple rewards, including CVX tokens and a cut of Curve trading fees, all on top of the base interest rate.',
      twitter: 'https://twitter.com/ConvexFinance',
      website: 'https://www.convexfinance.com/',
      telegram: 'https://t.me/convexEthChat',
    },
    primaryColor: '#1682FE',
    gradientColors: ['#61AAFF', '#1682FE'],
    gradientCoords: { x1: '54.64%', y1: '20%', x2: '16.1%', y2: '14.4%' },
  },
  {
    name: 'decentraland',
    displayName: 'Decentraland',
    decimals: 18,
    ticker: 'MANA',
    addresses: { current: '0x0F5D2fB29fb7d3CFeE444a200298f468908cC942' },
    info: {
      description:
        'Decentraland is building a virtual reality where users buy, develop, manage, and potentially sell a fixed number of LAND parcels. LAND ownership is recorded on the Ethereum blockchain and cannot be falsified or stolen. Users can develop their LAND and receive MANA for providing goods and services. LAND has already sold for as high as $215,000.',
      reddit: 'https://reddit.com/r/decentraland',
      twitter: 'https://twitter.com/decentraland',
      website: 'https://decentraland.org/',
    },
    primaryColor: '#FF2D55',
    gradientColors: ['#FF2D55', '#FFBC5B'],
    gradientCoords: { x1: '19.031%', y1: '-66.682%', x2: '123.324%', y2: '91.487%' },
  },
  {
    name: 'dent',
    displayName: 'Dent',
    decimals: 8,
    ticker: 'DENT',
    addresses: { current: '0x3597bfD533a99c9aa083587B074434E61Eb0A258' },
    primaryColor: '#FFFFFF',
    gradientColors: ['#EAEAEA', '#FFFFFF'],
    gradientCoords: { x1: '11.224%', y1: '-66.682%', x2: '141.81%', y2: '91.487%' },
  },
  {
    name: 'dydx',
    displayName: 'dYdX',
    decimals: 18,
    ticker: 'DYDX',
    addresses: { current: '0x92D6C1e31e14520e676a687F0a93788B716BEff5' },
    info: {
      description:
        'DYDX is the governance token of the dYdX decentralized trading platform. It is used to participate in staking pools, receive discounted trading fees and reap mining rewards.',
      reddit: 'https://www.reddit.com/r/dydxprotocol/',
      twitter: 'https://twitter.com/dydxprotocol',
      website: 'https://dydx.exchange/',
    },
    primaryColor: '#7373FF',
    gradientColors: ['#7373FF', '#5555BF'],
    gradientCoords: { x1: '100%', y1: '100%', x2: '0%', y2: '0%' },
  },
  {
    name: 'enjincoin',
    displayName: 'Enjin Coin',
    decimals: 18,
    ticker: 'ENJ',
    addresses: { current: '0xf629cbd94d3791c9250152bd8dfbdf380e2a3b9c' },
    info: {
      description:
        'ENJ tokens are used to back the value of NFTs, cryptocurrencies or currency for video games that are minted in the Enjin ecosystem.',
      reddit: 'https://www.reddit.com/r/EnjinCoin/',
      twitter: 'https://twitter.com/enjin',
      website: 'https://enjin.io/',
      telegram: 'https://t.me/enjin',
    },
    primaryColor: '#B5A7FF',
    gradientColors: ['#7866D5', '#B5A7FF'],
    gradientCoords: { x1: '119.625%', y1: '113.067%', x2: '0%', y2: '0%' },
  },
  {
    name: 'ens',
    displayName: 'Ethereum Name Service',
    decimals: 18,
    ticker: 'ENS',
    addresses: { current: '0xC18360217D8F7Ab5e7c516566761Ea12Ce7F9D72' },
    info: {
      description:
        'The Ethereum Name Service issues NFTs to convert long addresses into simple, memorable URLs such as “John.eth”. It’s based on the Ethereum blockchain but can link .eth addresses to a variety of machine-readable identifiers such as other cryptocurrency addresses, content hashes, metadata, and even domain names ending with .com, .org, etc.',
      twitter: 'https://twitter.com/ensdomains',
      website: 'https://ens.domains/',
    },
    primaryColor: '#5284FF',
    gradientColors: ['#9FBBFF', '#5284FF'],
    gradientCoords: { x1: '38%', y1: '37.5%', x2: '0.537%', y2: '6.714%' },
  },
  {
    name: 'fantom',
    displayName: 'Fantom Token',
    decimals: 18,
    ticker: 'FTM',
    addresses: { current: '0x4e15361fd6b4bb609fa63c81a2be19d873717870' },
    info: {
      description:
        'FTM is the primary token on the scalable Fantom blockchain platform, which is used for crypto dApps, DeFi and enterprise applications. It is used to secure the Fantom network via Proof-of-Stake.',
      reddit: 'https://www.reddit.com/r/FantomFoundation/',
      twitter: 'https://twitter.com/FantomFDN',
      website: 'https://fantom.foundation/',
    },
    primaryColor: '#13B5EC',
    gradientColors: ['#A0E7FF', '#13B5EC'],
    gradientCoords: { x1: '119.625%', y1: '113.067%', x2: '0%', y2: '0%' },
  },
  {
    name: 'fet_ethereum_6609900b',
    displayName: 'Fetch.ai',
    decimals: 18,
    ticker: 'FETethereum6609900B',
    displayTicker: 'FET',
    addresses: { current: '0xaea46A60368A7bD060eec7DF8CBa43b7EF41Ad85' },
    info: {
      description:
        'The FET token powers Fetch.ai, an ecosystem using AI and machine learning that uses “agents” to perform financial services such as DeFi trading, gig work management, and more.',
      reddit: 'https://www.reddit.com/r/FetchAI_Community/',
      twitter: 'https://twitter.com/fetch_ai',
      website: 'https://fetch.ai/',
      telegram: 'https://t.me/fetch_ai',
    },
    primaryColor: '#3D81F6',
    gradientColors: ['#2463EB', '#3D81F6'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '100%', y2: '100%' },
  },
  {
    name: 'forth_ethereum_52c00d9e',
    displayName: 'Ampleforth Governance',
    decimals: 18,
    ticker: 'FORTHethereum52C00D9E',
    displayTicker: 'FORTH',
    addresses: { current: '0x77FbA179C79De5B7653F68b5039Af940AdA60ce0' },
    info: {
      description:
        'The FORTH token powers the Ampleforth coin, which offers stability by inflating or deflating its supply according to current market conditions. FORTH holders can delegate votes or personally vote on decisions about the direction of the Ampleforth protocol.',
      twitter: 'https://twitter.com/AmpleforthOrg',
      website: 'https://www.ampleforth.org/',
    },
    primaryColor: '#8D8AF3',
    gradientColors: ['#5A56D6', '#8D8AF3'],
    gradientCoords: { x1: '3%', y1: '8.49%', x2: '41.043%', y2: '26.73%' },
  },
  {
    name: 'fox',
    displayName: 'Fox',
    decimals: 18,
    ticker: 'FOX',
    addresses: { current: '0xc770EEfAd204B5180dF6a14Ee197D99d808ee52d' },
    info: {
      description:
        'Fox is the governance and utility token of ShapeShift, a cross-chain crypto trading platform and portfolio manager for user self-sovereignty.',
      reddit: 'https://www.reddit.com/r/shapeshiftio/',
      twitter: 'https://twitter.com/ShapeShift_io',
      website: 'https://shapeshift.com/',
      telegram: 'https://t.me/shapeshiftofficial',
    },
    primaryColor: '#446DFF',
    gradientColors: ['#245AE5', '#245AE5'],
    gradientCoords: { x1: '91.53%', y1: '101%', x2: '10.067%', y2: '0%' },
  },
  {
    name: 'frax',
    displayName: 'Frax',
    decimals: 18,
    ticker: 'FRAX',
    addresses: { current: '0x853d955acef822db058eb8505911ed77f175b99e' },
    info: {
      description:
        'Frax is the world’s first stablecoin to be fractional-algorithmic, permissionless, and fully decentralized on-chain. It’s pegged to the US dollar and is 1 of 2 coins used in the Frax protocol—the other being a FXS, a governance token.',
      twitter: 'https://twitter.com/fraxfinance',
      website: 'https://frax.finance/#welcome',
      telegram: 'https://t.me/fraxfinance',
    },
    primaryColor: '#D4D4D4',
    gradientColors: ['#838383', '#D4D4D4'],
    gradientCoords: { x1: '3%', y1: '4%', x2: '36%', y2: '35.5%' },
  },
  {
    name: 'frax_share',
    displayName: 'Frax Share',
    decimals: 18,
    ticker: 'FXS',
    addresses: { current: '0x3432b6a60d23ca0dfca7761b7ab56459d9c964d0' },
    info: {
      description:
        'Frax Share is the governance token for the Frax protocol. This 2-token protocol is the world’s first fractional-algorithmic stablecoin system. The other token involved is FRAX, a stablecoin pegged to the US dollar.',
      twitter: 'https://twitter.com/fraxfinance',
      website: 'https://frax.finance/#welcome',
      telegram: 'https://t.me/fraxfinance',
    },
    primaryColor: '#D4D4D4',
    gradientColors: ['#838383', '#D4D4D4'],
    gradientCoords: { x1: '3%', y1: '4%', x2: '36%', y2: '35.5%' },
  },
  {
    name: 'funfair',
    displayName: 'FUNToken',
    decimals: 8,
    ticker: 'FUN',
    addresses: { current: '0x419D0d8BdD9aF5e606Ae2232ed285Aff190E711b' },
    info: {
      description:
        'FUNToken is the one-stop gaming token that will facilitate all forms of gaming with a transparent, provably fair and widely used mechanism for funding and integrating to disparate gaming opportunities.',
      reddit: 'https://www.reddit.com/r/FUNToken/',
      twitter: 'https://twitter.com/FUNtoken_io',
      website: 'https://funtoken.io/',
    },
    primaryColor: '#EC1966',
    gradientColors: ['#EC1966', '#E96C99'],
    gradientCoords: { x1: '100%', y1: '100%', x2: '0%', y2: '0%' },
  },
  {
    name: 'gala_ethereum_3e0e1736',
    displayName: 'GALA',
    decimals: 8,
    ticker: 'GALAethereum3E0E1736',
    displayTicker: 'GALA',
    addresses: { current: '0xd1d2Eb1B1e90B638588728b4130137D262C87cae' },
    info: {
      description:
        'The GALA token is used to pay for in-game purchases in Gala Games, a community-owned platform running on the Ethereum network. GALA is earned by playing games, but it can also be purchased from exchanges or earned by owning and operating a node.',
      twitter: 'https://twitter.com/GoGalaGames',
      website: 'https://app.gala.games/',
    },
    primaryColor: '#268AEF',
    gradientColors: ['#88C3FF', '#268AEF'],
    gradientCoords: { x1: '38%', y1: '37.5%', x2: '0.537%', y2: '6.714%' },
  },
  {
    name: 'geminidollar',
    displayName: 'Gemini Dollar',
    decimals: 2,
    ticker: 'GUSD',
    addresses: { current: '0x056Fd409E1d7A124BD7017459dFEa2F387b6d5Cd' },
    info: {
      description:
        'Gemini Dollar is an Ethereum-based stablecoin issued by Gemini Trust Company. Each unit of GUSD is backed by a unit of US Dollar in audited bank accounts in order to ensure 1 GUSD is always equal to 1 USD.',
      reddit: 'https://www.reddit.com/r/Gemini',
      twitter: 'https://twitter.com/gemini',
      website: 'https://gemini.com/dollar/',
    },
    primaryColor: '#00DCFA',
    gradientColors: ['#00DCFA', '#177EB7'],
    gradientCoords: { x1: '11.224%', y1: '-66.682%', x2: '141.81%', y2: '91.487%' },
  },
  {
    name: 'gnosis',
    displayName: 'Gnosis',
    decimals: 18,
    ticker: 'GNO',
    addresses: { current: '0x6810e776880C02933D47DB1b9fc05908e5386b96' },
    info: {
      description:
        'Gnosis is an Ethereum-based token representing decentralized prediction market allowing the predictions of future event outcomes.',
      reddit: 'https://www.reddit.com/r/gnosisPM/',
      twitter: 'https://twitter.com/gnosisPM',
      website: 'https://gnosis.pm/',
    },
    primaryColor: '#00A8C8',
    gradientColors: ['#00A8C8', '#146B7B'],
    gradientCoords: { x1: '22.351%', y1: '-12.223%', x2: '98.837%', y2: '152.777%' },
  },
  {
    name: 'golemv2',
    displayName: 'Golem',
    decimals: 18,
    ticker: 'GLM',
    addresses: { current: '0x7DD9c5Cba05E151C895FDe1CF355C9A1D5DA6429' },
    info: {
      description:
        'Golem is an Ethereum-based token allowing users to buy or sell computational power in the Golem protocol.',
      reddit: 'https://www.reddit.com/r/GolemProject/',
      twitter: 'https://twitter.com/golemproject',
      website: 'https://golem.network/',
    },
    primaryColor: '#0B81FF',
    gradientColors: ['#0B81FF', '#0B41D3'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '100%', y2: '100%' },
  },
  {
    name: 'holo',
    displayName: 'Holo',
    decimals: 18,
    ticker: 'HOT',
    addresses: { current: '0x6c6ee5e31d828de241282b9606c8e98ea48526e2' },
    info: {
      description:
        'HOT is used to power and make payments on Holochain platform decentralized apps. These are based on a more efficient blockchain system, using agents rather than energy-heavy, data-focused solutions.',
      reddit: 'https://www.reddit.com/r/holochain/',
      twitter: 'https://twitter.com/H_O_L_O_',
      website: 'https://holochain.org/',
      telegram: 'https://t.me/channelHolo',
    },
    primaryColor: '#00A4AF',
    gradientColors: ['#00454A', '#00A4AF'],
    gradientCoords: { x1: '119.625%', y1: '113.067%', x2: '0%', y2: '0%' },
  },
  {
    name: 'huobi',
    displayName: 'Huobi Token',
    decimals: 18,
    ticker: 'HT',
    addresses: { current: '0x6f259637dcD74C767781E37Bc6133cd6A68aa161' },
    info: {
      description:
        'HT is the native token of the Huobi cryptocurrency exchange. It rewards Huobi users with lower transaction fees on the exchange, while also maintaining its own asset value.',
      reddit: 'https://www.reddit.com/r/HuobiGlobal/',
      twitter: 'https://twitter.com/HuobiGlobal',
      website: 'https://www.huobiwallet.com/',
    },
    primaryColor: '#2CA6E0',
    gradientColors: ['#1B2143', '#2CA6E0'],
    gradientCoords: { x1: '119.625%', y1: '113.067%', x2: '0%', y2: '0%' },
  },
  {
    name: 'iexec',
    displayName: 'iExec',
    decimals: 9,
    ticker: 'RLC',
    addresses: { current: '0x607F4C5BB672230e8672085532f7e901544a7375' },
    info: {
      description:
        'iExec is an Ethereum-based token aiming to provide secure, scalable and easy to access services, data-sets, and computing resources for applications running on Ethereum.',
      reddit: 'https://www.reddit.com/r/iexec',
      twitter: 'https://twitter.com/iEx_ec',
      website: 'https://iex.ec',
      telegram: 'https://t.me/joinchat/FswFJw6AaL-kpQeWdBSwRA',
    },
    primaryColor: '#FFE900',
    gradientColors: ['#FFE900', '#FDC800'],
    gradientCoords: { x1: '22.351%', y1: '-12.223%', x2: '98.837%', y2: '152.777%' },
  },
  {
    name: 'illuvium',
    displayName: 'Illuvium',
    decimals: 18,
    ticker: 'ILV',
    addresses: { current: '0x767FE9EDC9E0dF98E07454847909b5E959D7ca0E' },
    info: {
      description:
        'Illuvium is an Ethereum-based RPG game where players can capture creatures and battle other players. Players can explore a powerful fantasy world built with Unreal Engine 4 and use DeFi features such as the IlluviDEX.',
      twitter: 'https://twitter.com/illuviumio',
      website: 'https://www.illuvium.io/',
      telegram: 'https://t.me/illuvium',
    },
    primaryColor: '#7474AA',
    gradientColors: ['#4B4B75', '#7474AA'],
    gradientCoords: { x1: '38%', y1: '37.5%', x2: '0.5%', y2: '6.7%' },
  },
  {
    name: 'imx',
    displayName: 'Immutable X',
    decimals: 18,
    ticker: 'IMX',
    addresses: { current: '0xF57e7e7C23978C3cAEC3C3548E3D615c346e79fF' },
    info: {
      description:
        'Immutable X is a scaling protocol for Ethereum NFTs. It offers near-instant trades, no gas fees, and low environmental impact. The IMX token can also be used for governance voting and staking.',
      reddit: 'https://www.reddit.com/r/ImmutableX/',
      twitter: 'https://twitter.com/Immutable',
      website: 'https://www.immutable.com/',
      telegram: 'https://t.me/immutablex',
    },
    primaryColor: '#24D1E9',
    gradientColors: ['#ADF5FF', '#24D1E9'],
    gradientCoords: { x1: '38%', y1: '37.5%', x2: '0.53%', y2: '6.714%' },
  },
  {
    name: 'jasmy_ethereum_2c1e076b',
    displayName: 'JasmyCoin',
    decimals: 18,
    ticker: 'JASMYethereum2C1E076B',
    displayTicker: 'JASMY',
    addresses: { current: '0x7420B4b9a0110cdC71fB720908340C03F9Bc03EC' },
    info: {
      description:
        'JASMY is the native token that powers Jasmy, an IOT platform created to transform how data is used by offering privacy, security, and payment innovations.',
      twitter: 'https://twitter.com/JasmyMGT',
      website: 'https://jasmy.co.jp/en.html',
      telegram: 'https://t.me/OfficialJasmyU',
    },
    primaryColor: '#F6941D',
    gradientColors: ['#F6941D', '#FFB545'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '100%', y2: '100%' },
  },
  {
    name: 'kyberv2',
    displayName: 'Kyber',
    decimals: 18,
    ticker: 'KNC',
    addresses: {
      current: '0xdeFA4e8a7bcBA345F687a2f1456F5Edd9CE97202', // proxy (implementation contract: 0xe5E8E834086F1a964f9A089eB6Ae11796862e4CE)
    },
    info: {
      description:
        'Kyber Network is an Ethereum--based liquidity protocol that aggregates liquidity from a wide range of reserves, powering instant and secure token exchange in any decentralized application.',
      reddit: 'https://www.reddit.com/r/kybernetwork/',
      twitter: 'https://twitter.com/kybernetwork',
      website: 'https://kyber.network/',
      telegram: 'https://t.me/kybernetwork',
    },
    primaryColor: '#31CB9E',
    gradientColors: ['#158866', '#31CB9E'],
    gradientCoords: { x1: '108.594%', y1: '100%', x2: '-19.892%', y2: '-20.421%' },
  },
  {
    name: 'leash_ethereum_562b149d',
    displayName: 'Doge Killer',
    decimals: 18,
    ticker: 'LEASHethereum562B149D',
    displayTicker: 'LEASH',
    addresses: {
      current: '0x27c70cd1946795b66be9d954418546998b546634',
    },
    info: {
      description:
        'LEASH is a loyalty token in the Shiba Inu ecosystem. Leash holders have benefited from exclusive perks like early access to Shiboshi NFT minting and Shib: The Metaverse land sales.',
      reddit: 'https://reddit.com/r/SHIBArmy',
      twitter: 'https://twitter.com/shibtoken',
      website: 'https://shibatoken.com/',
      telegram: 'https://t.me/shibainuthedogecoinkiller',
    },
    primaryColor: '#FFA409',
    gradientColors: ['#FF4D00', '#FFA409'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '100%', y2: '100%' },
  },
  {
    name: 'leo',
    displayName: 'Unus Sed Leo',
    decimals: 18,
    ticker: 'LEO',
    addresses: { current: '0x2AF5D2aD76741191D15Dfe7bF6aC92d4Bd912Ca3' },
    primaryColor: '#FFFFFF',
    gradientColors: ['#F3F3F3', '#FFFFFF'],
    gradientCoords: { x1: '19.031%', y1: '-66.682%', x2: '123.324%', y2: '91.487%' },
  },
  {
    name: 'lidodao',
    displayName: 'Lido DAO Token',
    decimals: 18,
    ticker: 'LDO',
    addresses: { current: '0x5A98FcBEA516Cf06857215779Fd812CA3beF1B32' },
    info: {
      description:
        'Lido is a DeFi staking platform that supports Ethereum, Terra, and Solana. Users can offer their tokens as collateral to earn even more via lending, yield farming, and more.',
      reddit: 'https://reddit.com/r/lidofinance',
      twitter: 'https://twitter.com/lidofinance',
      website: 'https://blog.lido.fi/',
      telegram: 'https://t.me/lidofinance',
    },
    primaryColor: '#00A3FF',
    gradientColors: ['#F3827B', '#EAEBA1'],
    gradientCoords: { x1: '20%', y1: '-3.5%', x2: '25.256%', y2: '43.411%' },
  },
  {
    name: 'livepeer',
    displayName: 'Livepeer',
    decimals: 18,
    ticker: 'LPT',
    addresses: { current: '0x58b6a8a3302369daec383334672404ee733ab239' },
    info: {
      description:
        'Livepeer is an open-source, decentralized protocol for live video streaming. It leverages Ethereum technology to offer a more streamlined service than what traditional, centralized broadcasting services offer.',
      reddit: 'https://reddit.com/r/livepeer',
      twitter: 'https://twitter.com/LivepeerOrg',
      website: 'https://livepeer.org/',
      telegram: 'https://t.me/livepeerorg',
    },
    primaryColor: '#00EB88',
    gradientColors: ['#00EB88', '#70F4BD'],
    gradientCoords: { x1: '2.681%', y1: '19.977%', x2: '37.32%', y2: '19.977%' },
  },
  {
    name: 'looks_ethereum_222f7656',
    displayName: 'LooksRare',
    decimals: 18,
    ticker: 'LOOKSethereum222F7656',
    displayTicker: 'LOOKS',
    addresses: { current: '0xf4d2888d29D722226FafA5d9B24F9164c092421E' },
    info: {
      description:
        'The LOOKS token powers LooksRare, a community-based and democratic NFT marketplace. LooksRare rewards users for activity such as staking LOOKS, buying NFTs, or listing NFTs.',
      twitter: 'https://twitter.com/LooksRareNFT',
      website: 'https://looksrare.org/',
    },
    primaryColor: '#0BC355',
    gradientColors: ['#0BC355', '#56EF93'],
    gradientCoords: { x1: '3%', y1: '8.49%', x2: '41.043%', y2: '26.73%' },
  },
  {
    name: 'loomv2',
    displayName: 'Loom',
    decimals: 18,
    ticker: 'LOOM',
    addresses: { current: '0x42476F744292107e34519F9c357927074Ea3F75D' },
    info: {
      description:
        'Loom is is an Ethereum-based token supporting a network of DPoS sidechains, which allows for highly-scalable games and user-facing dApps while still being backed by the security of Ethereum.',
      reddit: 'https://www.reddit.com/r/loomnetwork/',
      twitter: 'https://twitter.com/loomnetwork',
      website: 'https://loomx.io/',
      telegram: 'https://t.me/loomnetwork',
    },
    primaryColor: '#4BC0C8',
    gradientColors: ['#4BC0C8', '#02819B'],
    gradientCoords: { x1: '100%', y1: '100%', x2: '0%', y2: '0%' },
  },
  {
    name: 'loopring',
    displayName: 'Loopring',
    decimals: 18,
    ticker: 'LRC',
    addresses: { current: '0xBBbbCA6A901c926F240b89EacB641d8Aec7AEafD' },
    info: {
      description:
        'Loopring is an Ethereum-based token intended to serve as a building block to decentralized applications (DAPPs) that incorporate exchange functionality.',
      reddit: 'https://www.reddit.com/r/loopringorg/',
      twitter: 'https://twitter.com/loopringorg',
      website: 'https://loopring.org/',
      telegram: 'https://t.me/loopring_en',
    },
    primaryColor: '#589BFF',
    gradientColors: ['#1C42FF', '#589BFF'],
    gradientCoords: { x1: '38%', y1: '37.5%', x2: '0.53%', y2: '6.714%' },
  },
  {
    name: 'lqty_ethereum_126a91b0',
    displayName: 'Liquity',
    decimals: 18,
    ticker: 'LQTYethereum126A91B0',
    displayTicker: 'LQTY',
    addresses: { current: '0x6DEA81C8171D0bA574754EF6F8b412F2Ed88c54D' },
    info: {
      description:
        'The LQTY token powers Liquity, a borrowing app that charges one-time fees instead of interest when people take out loans. LQTY can be staked so users earn rewards from the fees paid when people open and close loans.',
      twitter: 'https://twitter.com/LiquityProtocol',
      website: 'https://liquity.org/',
    },
    primaryColor: '#745DDF',
    gradientColors: ['#745DDF', '#9E8AFE'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '100%', y2: '100%' },
  },
  {
    name: 'maker',
    displayName: 'Maker',
    decimals: 18,
    ticker: 'MKR',
    addresses: { current: '0x9f8F72aA9304c8B593d555F12eF6589cC3A579A2' },
    info: {
      description:
        'Maker is an Ethereum-based token that grants governance rights and network fee rewards in the Maker network. Maker’s stable-token Dai is unique in that it seeks to trade at $1 using blockchain technology and not bank reserves that face risks of being frozen or underfunded.',
      reddit: 'https://www.reddit.com/r/MakerDAO/',
      twitter: 'https://twitter.com/MakerDAO',
      website: 'https://makerdao.com/',
      telegram: 'https://t.me/makerdaoOfficial',
    },
    primaryColor: '#1ABC9C',
    gradientColors: ['#1ABC9C', '#546979'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '102%', y2: '101%' },
  },
  {
    name: 'mask_ethereum_c2890c79',
    displayName: 'Mask Network',
    decimals: 18,
    ticker: 'MASKethereumC2890C79',
    displayTicker: 'MASK',
    addresses: { current: '0x69af81e73A73B40adF4f3d4223Cd9b1ECE623074' },
    info: {
      description:
        'Mask Network brings privacy and benefits from Web3 to social media like Facebook & Twitter - with an open-sourced browser extension.',
      reddit: 'https://www.reddit.com/r/MaskNetwork/',
      twitter: 'https://twitter.com/realMaskNetwork',
      website: 'https://mask.io/',
      telegram: 'https://t.me/maskbook_group',
    },
    primaryColor: '#1C68F3',
    gradientColors: ['#1C68F3', '#0403BA'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '102%', y2: '101%' },
  },
  {
    name: 'mcd',
    displayName: 'Dai',
    decimals: 18,
    ticker: 'DAI',
    addresses: { current: '0x6B175474E89094C44Da98b954EedeAC495271d0F' },
    info: {
      description:
        'Dai is an Ethereum-based stablecoin issued by MakerDAO the value of which is stable relative to the US Dollar. The value of Dai is stabilized through a system of vaults (where multiple forms of supported collateral are held in smart contracts), autonomous feedback mechanisms, and appropriately incentivized external actors.',
      reddit: 'https://www.reddit.com/r/MakerDAO/',
      twitter: 'https://twitter.com/MakerDAO',
      website: 'https://makerdao.com/dai/',
      telegram: 'https://t.me/makerdaoOfficial',
    },
    primaryColor: '#FBCC5F',
    gradientColors: ['#FBCC5F', '#F9A606'],
    gradientCoords: { x1: '3.912%', y1: '0%', x2: '89.933%', y2: '100%' },
  },
  {
    name: 'mdt_ethereum_1bb644a2',
    displayName: 'Measurable Data Token',
    decimals: 18,
    ticker: 'MDTethereum1BB644A2',
    displayTicker: 'MDT',
    addresses: { current: '0x814e0908b12a99fecf5bc101bb5d0b8b5cdf7d26' },
    info: {
      description:
        'MDT is a utility token that facilitates the economy of the MDT ecosystem. MDT connects data providers, users, and buyers, denominating the data’s value when exchanged.',
      reddit: 'https://reddit.com/r/MeasurableDataToken',
      twitter: 'https://twitter.com/MeasurableData',
      website: 'http://mdt.io/',
      telegram: 'https://t.me/measurabledata',
    },
    primaryColor: '#8ACAFF',
    gradientColors: ['#4187F7', '#8ACAFF'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '100%', y2: '100%' },
  },
  {
    name: 'metis_ethereum_54dc1156',
    displayName: 'Metis DAO',
    decimals: 18,
    ticker: 'METISethereum54DC1156',
    displayTicker: 'Metis',
    addresses: { current: '0x9E32b13ce7f2E80A01932B42553652E053D6ed8e' },
    info: {
      description:
        'Metis DAO makes it easy for beginners to create dApps and Decentralized Autonomous Communities—even without coding. The goal is to help businesses move their projects and services from Web2 to Web3.',
      twitter: 'https://twitter.com/MetisDAO',
      website: 'https://www.metis.io/',
      telegram: 'https://t.me/MetisDAO',
    },
    primaryColor: '#2ADACC',
    gradientColors: ['#17978D', '#2ADACC'],
    gradientCoords: { x1: '3%', y1: '8.4%', x2: '41.04%', y2: '26.7%' },
  },
  {
    name: 'nexo_ethereum_fe4d2476',
    displayName: 'Nexo',
    decimals: 18,
    ticker: 'NEXOethereumFE4D2476',
    displayTicker: 'NEXO',
    addresses: { current: '0xB62132e35a6c13ee1EE0f84dC5d40bad8d815206' },
    info: {
      description:
        'The NEXO Token is the key to unlocking the full potential of Nexo. Get even higher earning rates and our lowest borrowing rates.',
      reddit: 'https://www.reddit.com/r/Nexo/',
      twitter: 'https://twitter.com/Nexo',
      website: 'https://nexo.io/',
      telegram: 'https://t.me/nexofinance',
    },
    primaryColor: '#3CA9E5',
    gradientColors: ['#3CA9E5', '#1A4199'],
    gradientCoords: { x1: '11.224%', y1: '-66.682%', x2: '141.81%', y2: '91.487%' },
  },
  {
    name: 'mxc_ethereum_c4923be4',
    displayName: 'MXC',
    decimals: 18,
    ticker: 'MXCethereumC4923BE4',
    displayTicker: 'MXC',
    addresses: { current: '0x5Ca381bBfb58f0092df149bD3D243b08B9a8386e' },
    info: {
      description:
        'The MXC token is used to govern and power the MXC Protocol, which allows individuals, companies, and organizations to access its large LPWAN network. MXC can also be staked so profits are shared with the community.',
      reddit: 'https://reddit.com/r/MXC_Foundation',
      twitter: 'https://twitter.com/mxcfoundation',
      website: 'https://www.mxc.org/',
    },
    primaryColor: '#6300FF',
    gradientColors: ['#6300FF', '#8000FF'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '100%', y2: '100%' },
  },
  {
    name: 'numeraire',
    displayName: 'Numeraire',
    decimals: 18,
    ticker: 'NMR',
    addresses: { current: '0x1776e1F26f98b1A5dF9cD347953a26dd3Cb46671' },
    info: {
      description:
        'Numeraire is an Ethereum-based token used as a reward for data scientists for financial market predictions.',
      reddit: 'https://www.reddit.com/r/numerai',
      twitter: 'https://twitter.com/Numerai',
      website: 'https://numer.ai',
      telegram: 'https://t.me/NMR_Official',
    },
    primaryColor: '#0AFA99',
    gradientColors: ['#0AFA99', '#E1E64E'],
    gradientCoords: { x1: '11.224%', y1: '-66.682%', x2: '141.81%', y2: '91.487%' },
  },
  {
    name: 'ogn_ethereum_fcc7cc39',
    displayName: 'Origin Token',
    decimals: 18,
    ticker: 'OGNethereumFCC7CC39',
    displayTicker: 'OGN',
    addresses: { current: '0x8207c1FfC5B6804F6024322CcF34F29c3541Ae26' },
    info: {
      description:
        'Origin Token is used for staking and governance in the Origin ecosystem, a suite of products that empower apps with DeFi, NFTs, and decentralization.',
      reddit: 'https://reddit.com/r/originprotocol',
      twitter: 'https://twitter.com/originprotocol',
      website: 'https://www.originprotocol.com',
    },
    primaryColor: '#1A82FF',
    gradientColors: ['#1A82FF', '#71B1FF'],
    gradientCoords: { x1: '2.68%', y1: '0.61%', x2: '41.19%', y2: '35.03%' },
  },
  {
    name: 'olympusv2',
    displayName: 'Olympus v2',
    decimals: 9,
    ticker: 'OHM',
    addresses: { current: '0x64aa3364F17a4D01c6f1751Fd97C2BD3D7e7f1D5' },
    info: {
      description:
        'Olympus is an algorithmic stablecoin backed by DAI instead of US dollars. Because it’s backed by another cryptocurrency, its price in USD can fluctuate.',
      reddit: 'https://reddit.com/r/OlympusDAO',
      twitter: 'https://twitter.com/OlympusDAO',
      website: 'https://docs.olympusdao.finance/',
      telegram: 'https://t.me/s/OlympusDAO',
    },
    primaryColor: '#788299',
    gradientColors: ['#788299', '#ADB8D3'],
    gradientCoords: { x1: '9.954%', y1: '7.596%', x2: '34.509%', y2: '31.978%' },
  },
  {
    name: 'omisego',
    displayName: 'OMG',
    decimals: 18,
    ticker: 'OMG',
    addresses: { current: '0xd26114cd6EE289AccF82350c8d8487fedB8A0C07' },
    info: {
      description:
        'The OMG Network is the quickest and most affordable way to transfer ETH and ERC20 tokens globally without restrictions. Formerly known as OmiseGo, OMG Network was established in 2017 as a trustless, non-custodial Layer-2 scaling solution for transferring value on Ethereum. The OMG Network enables the transfer of ETH and ERC20 tokens with a throughput of thousands of transactions per second, scaling Ethereum and making it Enterprise-ready.',
      reddit: 'https://www.reddit.com/r/OMGnetwork/',
      twitter: 'https://twitter.com/omgnetworkhq',
      website: 'https://omg.network/',
      telegram: 'https://omg.eco/telegram',
    },
    primaryColor: '#4967FF',
    gradientColors: ['#4947FF', '#3248B3'],
    gradientCoords: { x1: '22.351%', y1: '-12.223%', x2: '98.837%', y2: '152.777%' },
  },
  {
    name: 'oneinch',
    displayName: '1inch',
    decimals: 18,
    ticker: '1INCH',
    addresses: { current: '0x111111111117dC0aa78b770fA6A738034120C302' },
    info: {
      description:
        '1Inch is an exchange aggregator, meaning that it scans various decentralized exchanges to locate the lowest crypto price for traders.',
      reddit: 'https://www.reddit.com/r/1inch/',
      twitter: 'https://twitter.com/1inch',
      website: 'https://1inch.io/',
      telegram: 'https://t.me/OneInchNetwork',
    },
    primaryColor: '#2F79EA',
    gradientColors: ['#2F79EA', '#124282'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '100%', y2: '100%' },
  },
  {
    name: 'ousd_ethereum_48fcf72d',
    displayName: 'Origin Dollar',
    decimals: 18,
    ticker: 'OUSDethereum48FCF72D',
    displayTicker: 'OUSD',
    addresses: { current: '0x2A8e1E676Ec238d8A992307B495b45B3fEAa5e86' },
    info: {
      description:
        'Origin Dollar is a stablecoin in the Origin ecosystem, a suite of products that empower apps with DeFi, NFTs, and decentralization. It’s the first crypto stablecoin that earns yield automatically when held—no staking or unstaking required.',
      reddit: 'https://reddit.com/r/originprotocol',
      twitter: 'https://twitter.com/originprotocol',
      website: 'https://www.ousd.com/',
    },
    primaryColor: '#1A82FF',
    gradientColors: ['#1A82FF', '#71B1FF'],
    gradientCoords: { x1: '25.38%', y1: '15.89%', x2: '27.48%', y2: '24.56%' },
  },
  {
    name: 'paxgold',
    displayName: 'PAX Gold',
    decimals: 18,
    ticker: 'PAXG',
    addresses: { current: '0x45804880De22913dAFE09f4980848ECE6EcbAf78' },
    info: {
      description:
        'PAX Gold (PAXG) is a digital token backed by physical gold. Each token is backed by one fine troy ounce (t oz) of a 400 oz London Good Delivery gold bar, stored in Brink’s vaults. Anyone who owns PAXG owns the underlying physical gold, held in custody by Paxos Trust Company.',
      twitter: 'https://twitter.com/paxosglobal',
      website: 'https://www.paxos.com/paxgold',
    },
    primaryColor: '#DEC21C',
    gradientColors: ['#DEC21C', '#EFE812'],
    gradientCoords: { x1: '19.031%', y1: '-66.682%', x2: '123.324%', y2: '91.487%' },
  },
  {
    name: 'paxos',
    displayName: 'Paxos',
    decimals: 18,
    ticker: 'PAX',
    displayTicker: 'USDP',
    addresses: { current: '0x8E870D67F660D95d5be530380D0eC0bd388289E1' },
    info: {
      description:
        'Paxos is an Ethereum-based token designed as a stablecoin issued by the Paxos Trust Company. Paxos tokens are backed by deposits in US bank accounts to ensure 1 USDP equals 1 USD.',
      reddit: 'https://www.reddit.com/r/PaxosStandardToken/',
      twitter: 'https://twitter.com/paxosglobal',
      website: 'https://www.paxos.com/standard',
    },
    primaryColor: '#EAE522',
    gradientColors: ['#EAE522', '#EAD422'],
    gradientCoords: { x1: '11.224%', y1: '-66.682%', x2: '141.81%', y2: '91.487%' },
  },
  {
    name: 'perp_ethereum_c75f71b4',
    displayName: 'Perpetual Protocol',
    decimals: 18,
    ticker: 'PERPethereumC75F71B4',
    displayTicker: 'PERP',
    addresses: { current: '0xbc396689893d065f41bc2c6ecbee5e0085233447' },
    info: {
      description:
        'PERP is the native utility and governance token for Perpetual Protocol, a DEX that offers leveraged trading, short positions, and low slippage.',
      twitter: 'https://twitter.com/perpprotocol',
      website: 'https://perp.com/',
    },
    primaryColor: '#0052FF',
    gradientColors: ['#0052FF', '#3E7CFF'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '100%', y2: '100%' },
  },
  {
    name: 'pepe_ethereum_22ed551c',
    displayName: 'Pepe',
    decimals: 18,
    ticker: 'PEPEethereum22ED551C',
    displayTicker: 'PEPE',
    addresses: { current: '0x6982508145454Ce325dDbE47a25d4ec3d2311933' },
    info: {
      description:
        'PEPE is a deflationary memecoin named after the internet character Pepe the Frog. It aims to be an entertaining alternative to dog-themed memecoins, plus reward long-term holders.',
      twitter: 'https://twitter.com/pepecoineth',
      website: 'https://www.pepe.vip/',
      telegram: 'https://t.me/pepecoineth',
    },
    primaryColor: '#5E924B',
    gradientColors: ['#5E924B', '#7DBE65'],
    gradientCoords: { x1: '4%', y1: '9%', x2: '39.09%', y2: '27.54%' },
  },
  {
    name: 'polygon',
    displayName: 'Polygon',
    decimals: 18,
    ticker: 'MATIC',
    addresses: { current: '0x7D1AfA7B718fb893dB30A3aBc0Cfc608AaCfeBB0' },
    info: {
      description:
        'Polygon (previously Matic Network) is a protocol and a framework for building and connecting Ethereum-compatible blockchain networks. Aggregating scalable solutions on Ethereum supporting a multi-chain Ethereum ecosystem.',
      reddit: 'https://www.reddit.com/r/0xPolygon/',
      twitter: 'https://twitter.com/0xPolygon',
      website: 'https://polygon.technology/',
      telegram: 'https://t.me/polygonofficial',
    },
    primaryColor: '#9962f6',
    gradientColors: ['#5A63B8', '#C86DD7'],
    gradientCoords: { x1: '19.031%', y1: '-66.682%', x2: '123.324%', y2: '91.487%' },
  },
  {
    name: 'pol_ethereum_e5c9fadc',
    displayName: 'Polygon Ecosystem Token',
    decimals: 18,
    tickerAlias: 'POL',
    ticker: 'POLethereumE5C9FADC',
    displayTicker: 'POL',
    addresses: { current: '0x455e53CBB86018Ac2B8092FdCd39d8444aFFC3F6' },
    info: {
      description:
        'The Polygon Ecosystem Token serves as a utility token within the expansive Polygon network. Its primary functions include staking, where token holders can lock up their tokens as a form of security and in return, participate in the network consensus mechanisms.',
      reddit: 'https://www.reddit.com/r/0xPolygon/',
      twitter: 'https://x.com/0xPolygon',
      website:
        'https://polygon.technology/blog/polygon-2-0-milestone-pol-contracts-are-live-on-ethereum-mainnet',
    },
    primaryColor: '#9962f6',
    gradientColors: ['#5A63B8', '#C86DD7'],
    gradientCoords: { x1: '19.031%', y1: '-66.682%', x2: '123.324%', y2: '91.487%' },
  },
  {
    name: 'powerledger',
    displayName: 'Power Ledger',
    decimals: 6,
    ticker: 'POWR',
    addresses: { current: '0x595832F8FC6BF59c85C527fEC3740A1b7a361269' },
    info: {
      description:
        'Power Ledger is an Ethereum-based token to enable peer-to-peer trading of renewable energy.',
      reddit: 'https://www.reddit.com/r/PowerLedger/',
      twitter: 'https://twitter.com/powerledger_io',
      website: 'https://powerledger.io',
      telegram: 'https://t.me/powerledger',
    },
    primaryColor: '#05BCA9',
    gradientColors: ['#05BCA9', '#2F4B77'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '102%', y2: '101%' },
  },
  {
    name: 'pyusd_ethereum_871d3761',
    displayName: 'PayPal USD',
    decimals: 6,
    ticker: 'PYUSD',
    addresses: { current: '0x6c3ea9036406852006290770BEdFcAbA0e23A0e8' },
    info: {
      description: 'A stablecoin pegged to the US Dollar, issued by PayPal.',
      website: 'https://www.paypal.com/pyusd',
    },
    primaryColor: '#0071F3',
    gradientColors: ['#0071F3', '#338EF8'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '100%', y2: '100%' },
  },
  {
    name: 'quant',
    displayName: 'Quant',
    decimals: 18,
    ticker: 'QNT',
    addresses: { current: '0x4a220e6096b25eadb88358cb44068a3248254675' },
    info: {
      description:
        'QNT tokens provide digital access to services or applications on the Quant platform. This includes the Overledger blockchain OS, which helps multiple blockchains and global networks interoperate.',
      reddit: 'https://www.reddit.com/r/QuantNetwork/',
      twitter: 'https://twitter.com/quant_network',
      website: 'https://www.quant.network/',
      telegram: 'https://t.me/QuantOverledger',
    },
    primaryColor: '#EF4F1F',
    gradientColors: ['#D72D2F', '#EF4F1F'],
    gradientCoords: { x1: '119.625%', y1: '113.067%', x2: '0%', y2: '0%' },
  },
  {
    name: 'radar_ethereum_e4d48030',
    displayName: 'DappRadar',
    decimals: 18,
    ticker: 'RADARethereumE4D48030',
    displayTicker: 'RADAR',
    addresses: { current: '0x44709a920fCcF795fbC57BAA433cc3dd53C44DbE' },
    info: {
      description:
        'RADAR is the governance token of DappRadar, a popular platform for discovering and exploring dApps. RADAR also grants users access to DappRadar PRO and its exclusive content, private channels, notifications, and more.',
      twitter: 'https://twitter.com/dappradar',
    },
    primaryColor: '#006CFF',
    gradientColors: ['#006CFF', '#4694FF'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '100%', y2: '100%' },
  },
  {
    name: 'rarible',
    displayName: 'Rarible',
    decimals: 18,
    ticker: 'RARI',
    addresses: { current: '0xfca59cd816ab1ead66534d82bc21e7515ce441cf' },
    info: {
      description:
        'Rarible is a creator-centric NFT marketplace and issuance platform that utilizes the RARI token to empower users who actively interact with the protocol.',
      reddit: 'https://www.reddit.com/r/Rarible/',
      twitter: 'https://twitter.com/rariblecom',
      website: 'https://app.rarible.com/rari',
    },
    primaryColor: '#0180FF',
    gradientColors: ['#0180FF', '#013CFF'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '102%', y2: '101%' },
  },
  {
    name: 'ren',
    displayName: 'Ren',
    decimals: 18,
    ticker: 'REN',
    addresses: { current: '0x408e41876cCCDC0F92210600ef50372656052a38' },
    info: {
      description:
        'Ren is the token of RenVM ecosystem, a decentralized protocol for allowing applications to have access to cryptocurrency assets from different blockchains in one platform.',
      reddit: 'https://www.reddit.com/r/renproject',
      twitter: 'https://twitter.com/renprotocol',
      website: 'https://renproject.io/',
      telegram: 'https://t.me/renproject',
    },
    primaryColor: '#FFFFFF',
    gradientColors: ['#FFFFFF', '#EBEBEB'],
    gradientCoords: { x1: '0%', y1: '21.958%', x2: '99.12%', y2: '78.676%' },
  },
  {
    name: 'render',
    displayName: 'Render',
    decimals: 18,
    ticker: 'RNDR',
    addresses: { current: '0x6De037ef9aD2725EB40118Bb1702EBb27e4Aeb24' },
    info: {
      description:
        'Render is an ERC-20 token that creators can pay to node operators to get GPU rendering power for their work on images, animation, and special effects. This saves creators money as it’s cheaper than in-house rendering, and it allows node operators to earn RNDR with their idle GPUs.',
      reddit: 'https://www.reddit.com/r/RenderToken/',
      twitter: 'https://twitter.com/rendertoken',
      website: 'https://rendertoken.com/',
      telegram: 'https://t.me/RenderTokenOfficial',
    },
    primaryColor: '#FF5A5A',
    gradientColors: ['#E62249', '#FF5A5A'],
    gradientCoords: { x1: '38%', y1: '37.5%', x2: '0.537%', y2: '6.714%' },
  },
  {
    name: 'request',
    displayName: 'Request',
    decimals: 18,
    ticker: 'REQ',
    addresses: { current: '0x8f8221aFbB33998d8584A2B05749bA73c37a938a' },
    info: {
      description:
        'Request is an Ethereum-based token that allows anyone, anywhere to request a payment.',
      reddit: 'https://www.reddit.com/r/RequestNetwork/',
      twitter: 'https://twitter.com/requestnetwork',
      website: 'https://request.network/',
      telegram: 'https://t.me/requestnetwork',
    },
    primaryColor: '#6CFDCC',
    gradientColors: ['#5A89F9', '#6CFDCC'],
    gradientCoords: { x1: '-28.432%', y1: '0%', x2: '-28.432%', y2: '99.999%' },
  },
  {
    name: 'reth_ethereum_40b16905',
    displayName: 'Rocket Pool ETH',
    decimals: 18,
    ticker: 'RETHethereum40B16905',
    displayTicker: 'rETH',
    addresses: { current: '0xae78736Cd615f374D3085123A210448E74Fc6393' },
    info: {
      description:
        'Rocket Pool ETH is a decentralized staking pool for Ethereum. When users stake ETH on Rocket Pool, they receive rETH, which earns interest and can be exchanged back anytime.',
      reddit: 'https://reddit.com/r/rocketpool',
      twitter: 'https://twitter.com/Rocket_Pool',
      website: 'https://www.rocketpool.net/',
    },
    primaryColor: '#FEF08A',
    gradientColors: ['#EAB308', '#FEF08A'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '102%', y2: '101%' },
  },
  {
    name: 'rlb_ethereum_a7e53179',
    displayName: 'Rollbit Coin',
    decimals: 18,
    ticker: 'RLBethereumA7E53179',
    displayTicker: 'RLB',
    addresses: { current: '0x046EeE2cc3188071C02BfC1745A6b17c656e3f3d' },
    info: {
      description:
        "Rollbit is Crypto's Most Rewarding Casino. Rollbit is committed to creating unique and fun experiences for it's users.",
      twitter: 'https://twitter.com/rollbitcom',
      website: 'https://rollbit.com/',
    },
    primaryColor: '#FEA101',
    gradientColors: ['#FEA101', '#FFB941'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '20%', y2: '20%' },
  },
  {
    name: 'rpl_ethereum_2f6fb917',
    displayName: 'Rocket Pool Protocol',
    decimals: 18,
    ticker: 'RPLethereum2F6FB917',
    displayTicker: 'RPL',
    addresses: { current: '0xD33526068D116cE69F19A9ee46F0bd304F21A51f' },
    info: {
      description:
        'Rocket Pool ETH is a decentralized staking pool for Ethereum. It democratizes ETH staking by allowing users to stake amounts as low as 0.01 ETH. Users can also run their own node with just 16 ETH instead of the usual 32 required.',
      reddit: 'https://reddit.com/r/rocketpool',
      twitter: 'https://twitter.com/Rocket_Pool',
      website: 'https://www.rocketpool.net/',
    },
    primaryColor: '#FEF08A',
    gradientColors: ['#EAB308', '#FEF08A'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '102%', y2: '101%' },
  },
  {
    name: 'rsr_ethereum_a5eb8f84',
    displayName: 'Reserve Rights',
    decimals: 18,
    ticker: 'RSRethereumA5EB8F84',
    displayTicker: 'RSR',
    addresses: { current: '0x320623b8e4ff03373931769a31fc52a4e78b5d70' },
    info: {
      description:
        'RSR is a utility and governance token for the Reserve Protocol, an ecosystem that offers stability to the world of crypto by allowing anyone to easily create stablecoins.',
      reddit: 'https://reddit.com/r/ReserveProtocol',
      twitter: 'https://twitter.com/reserveprotocol',
      website: 'https://reserve.org/',
    },
    primaryColor: '#F6F6F6',
    gradientColors: ['#D6D6D6', '#F6F6F6'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '100%', y2: '100%' },
  },
  {
    name: 'sandbox',
    displayName: 'The Sandbox',
    decimals: 18,
    ticker: 'SAND',
    addresses: { current: '0x3845badAde8e6dFF049820680d1F14bD3903a5d0' },
    info: {
      description:
        'The Sandbox is an expansive metaverse community where users can be creative and monetize their games, artwork, and more.',
      reddit: 'https://www.reddit.com/r/TheSandboxGaming/',
      twitter: 'https://twitter.com/thesandboxgame',
      website: 'https://www.sandbox.game/',
      telegram: 'https://t.me/sandboxgame',
    },
    primaryColor: '#00ADEF',
    gradientColors: ['#0084FF', '#00ADEF'],
    gradientCoords: { x1: '9.954%', y1: '7.596%', x2: '34.509%', y2: '31.978%' },
  },
  {
    name: 'sdao_ethereum_c59ee345',
    displayName: 'Singularity DAO',
    decimals: 18,
    ticker: 'SDAOethereumC59EE345',
    displayTicker: 'SDAO',
    addresses: { current: '0x993864e43caa7f7f12953ad6feb1d1ca635b875f' },
    info: {
      description:
        'SDAO token is the governance token of the SingularityDAO. The DAO leverages AI and smart contracts for DeFI portfolio management.',
      twitter: 'https://twitter.com/SingularityDao',
      website: 'https://www.singularitydao.ai/',
    },
    primaryColor: '#D020D6',
    gradientColors: ['#0FAE91', '#D020D6'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '100%', y2: '100%' },
  },
  {
    name: 'shibainu',
    displayName: 'Shiba Inu',
    decimals: 18,
    ticker: 'SHIB',
    addresses: { current: '0x95aD61b0a150d79219dCF64E1E6Cc01f0B64C4cE' },
    info: {
      description:
        'Calling itself “the Dogecoin killer,” SHIB is purely a transferable token named after an adorable breed of dog. ',
      reddit: 'https://www.reddit.com/r/SHIBArmy/',
      twitter: 'https://twitter.com/shibtoken',
      website: 'https://shibatoken.com/',
    },
    primaryColor: '#F69C0A',
    gradientColors: ['#A53803', '#F69C0A'],
    gradientCoords: { x1: '119.625%', y1: '113.067%', x2: '0%', y2: '0%' },
  },
  {
    name: 'smoothlovepotion',
    displayName: 'Smooth Love Potion',
    decimals: 0,
    ticker: 'SLP',
    addresses: { current: '0xCC8Fa225D80b9c7D42F96e9570156c65D6cAAa25' },
    info: {
      description:
        'Smooth Love Potion (SLP) tokens are digital coins earned by players in Axie Infinity, where creatures (Axies) can be bred using SLP.',
      reddit: 'https://reddit.com/r/AxieInfinity',
      twitter: 'https://twitter.com/AxieInfinity',
      website: 'https://axieinfinity.com/',
      telegram: 'https://t.me/axieinfinity',
    },
    primaryColor: '#77BAA1',
    gradientColors: ['#77BAA1', '#B9EFDB'],
    gradientCoords: { x1: '-3.98%', y1: '1.381%', x2: '49.273%', y2: '30.414%' },
  },
  {
    name: 'snx',
    displayName: 'Synthetix',
    decimals: 18,
    ticker: 'SNX',
    addresses: {
      current: '0xC011a73ee8576Fb46F5E1c5751cA3B9Fe0af2a6F',
      previous: ['0xC011A72400E58ecD99Ee497CF89E3775d4bd732F'],
    },
    info: {
      description:
        'SNX is the token of the Synthetix Network, a decentralized protocol allowing anyone to mint their own synthetic asset with the value backed by the SNX token.',
      twitter: 'https://twitter.com/synthetix_io',
      website: 'https://www.synthetix.io/',
    },
    primaryColor: '#00D1FF',
    gradientColors: ['#00D1FF', '#005466'],
    gradientCoords: { x1: '0%', y1: '21.958%', x2: '99.12%', y2: '78.676%' },
  },
  {
    name: 'status',
    displayName: 'Status',
    decimals: 18,
    ticker: 'SNT',
    addresses: { current: '0x744d70FDBE2Ba4CF95131626614a1763DF805B9E' },
    info: {
      description:
        'Status is an Ethereum-based token created as an open source messaging platform and mobile browser allowing users to interact with decentralized applications (dApps) on the Ethereum Network.',
      reddit: 'https://www.reddit.com/r/status_token/',
      twitter: 'https://twitter.com/ethstatus',
      website: 'https://status.im/',
    },
    primaryColor: '#5B67C3',
    gradientColors: ['#5B67C3', '#3B4382'],
    gradientCoords: { x1: '22.351%', y1: '-12.223%', x2: '98.837%', y2: '152.777%' },
  },
  {
    name: 'steth',
    displayName: 'Lido Staked ETH',
    decimals: 18,
    ticker: 'STETH',
    displayTicker: 'stETH',
    addresses: { current: '0xae7ab96520de3a18e5e111b5eaab095312d7fe84' },
    info: {
      description:
        'When someone stakes their ETH with Lido, they earn staking rewards from ETH 2.0 and also instantly receive stETH tokens. Just like ETH, stETH can be traded, used for payments, and used in DeFi.',
      reddit: 'https://reddit.com/r/lidofinance',
      twitter: 'https://twitter.com/lidofinance',
      website: 'https://lido.fi/',
    },
    primaryColor: '#00A3FF',
    gradientColors: ['#00A3FF', '#3ADCFF'],
    gradientCoords: { x1: '19.031%', y1: '-66.682%', x2: '123.324%', y2: '91.487%' },
  },
  {
    name: 'storj',
    displayName: 'Storj',
    decimals: 8,
    ticker: 'STORJ',
    addresses: { current: '0xB64ef51C888972c908CFacf59B47C1AfBC0Ab8aC' },
    info: {
      description:
        'Storj is a decentralized cloud storage platform allowing anyone to rent out unused hard drive space and earn money. Storage providers are paid in the Ethereum-based STORJ while users benefit from file encryption, low costs, and fast performance.',
      reddit: 'https://www.reddit.com/r/storj/',
      twitter: 'https://twitter.com/storjproject',
      website: 'https://storj.io/',
    },
    primaryColor: '#15528E',
    gradientColors: ['#0081FF', '#15528E'],
    gradientCoords: { x1: '25.019%', y1: '-6.467%', x2: '98.837%', y2: '152.777%' },
  },
  {
    name: 'sushiswap',
    displayName: 'SushiSwap',
    decimals: 18,
    ticker: 'SUSHI',
    addresses: { current: '0x6B3595068778DD592e39A122f4f5a5cF09C90fE2' },
    primaryColor: '#FC53A2',
    gradientColors: ['#FC53A2', '#B074BA'],
    gradientCoords: { x1: '0%', y1: '-0.006%', x2: '100%', y2: '100%' },
  },
  {
    name: 'syn_ethereum_c7f5e6b8',
    displayName: 'Synapse',
    decimals: 18,
    ticker: 'SYNethereumC7F5E6B8',
    displayTicker: 'SYN',
    addresses: { current: '0x0f2D719407FdBeFF09D87557AbB7232601FD9F29' },
    info: {
      description:
        'The Synapse token powers the Synapse ecosystem, a trustless AMM and bridge that enables transfers, swaps, rewards, and more between blockchains.',
      twitter: 'https://twitter.com/SynapseProtocol',
      website: 'https://synapseprotocol.com/',
      telegram: 'https://t.me/synapseprotocol',
    },
    primaryColor: '#F506FA',
    gradientColors: ['#F506FA', '#FD89FF'],
    gradientCoords: { x1: '8.49%', y1: '6%', x2: '32%', y2: '32.86%' },
  },
  {
    name: 'tel_ethereum_02bc2dbb',
    displayName: 'Telcoin',
    decimals: 2,
    ticker: 'TELethereum02BC2DBB',
    displayTicker: 'TEL',
    addresses: { current: '0x467Bccd9d29f223BcE8043b84E8C8B282827790F' },
    info: {
      description:
        'TEL is the native token for Telcoin, a DeFi platform that provides a variety of finance products to mobile phone users. Specifically, it offers cheap, fast, and secure remittances around the world.',
      reddit: 'https://reddit.com/r/telcoin',
      twitter: 'https://twitter.com/telcoin_team',
      website: 'https://www.telco.in/',
    },
    primaryColor: '#14C8FF',
    gradientColors: ['#14C8FF', '#8EE5FF'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '100%', y2: '100%' },
  },
  {
    name: 'tetherusd',
    displayName: 'Tether USD',
    decimals: 6,
    ticker: 'USDT',
    addresses: { current: '0xdAC17F958D2ee523a2206206994597C13D831ec7' },
    info: {
      description:
        'Tether is a multi-chain stablecoin. Each USDT token is designed to be backed by a U.S. Dollar held in banking reserves.',
      reddit: 'https://www.reddit.com/r/Tether/',
      twitter: 'https://twitter.com/tether_to',
      website: 'https://tether.to/',
    },
    primaryColor: '#53AE94',
    gradientColors: ['#53AE94', '#2E9175'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '102%', y2: '101%' },
  },
  {
    name: 'thegraph',
    displayName: 'The Graph',
    decimals: 18,
    ticker: 'GRT',
    addresses: { current: '0xc944E90C64B2c07662A292be6244BDf05Cda44a7' },
    info: {
      description:
        'The Graph is an indexing protocol for querying networks like Ethereum and IPFS.',
      reddit: 'https://reddit.com/r/thegraph',
      twitter: 'https://twitter.com/graphprotocol',
      website: 'https://thegraph.com/',
      telegram: 'https://t.me/graphprotocol',
    },
    primaryColor: '#33A0FF',
    gradientColors: ['#33A0FF', '#5919D9'],
    gradientCoords: { x1: '73.306%', y1: '69.023%', x2: '0%', y2: '0%' },
  },
  {
    name: 'tru_ethereum_922b250a',
    displayName: 'TrueFi',
    decimals: 8,
    ticker: 'TRUethereum922B250A',
    displayTicker: 'TRU',
    addresses: {
      current: '0x4c19596f5aaff459fa38b0f7ed92f11ae6543784',
    },
    info: {
      description:
        'The TRU token is used for staking and governance on TrueFi, a platform that offers collateral-free lending. The platform values transparency, vets borrowers, and is governed by TRU holders.',
      reddit: 'https://reddit.com/r/TrustToken',
      twitter: 'https://twitter.com/TrustToken',
      website: 'https://truefi.io/',
    },
    primaryColor: '#1A5AFF',
    gradientColors: ['#1A5AFF', '#6691FF'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '100%', y2: '100%' },
  },
  {
    name: 'trb_ethereum_ad699fe9',
    displayName: 'Tellor Tributes',
    decimals: 18,
    ticker: 'TRBethereumAD699FE9',
    displayTicker: 'TRB',
    addresses: {
      current: '0x88df592f8eb5d7bd38bfef7deb0fbc02cf3778a0',
    },
    info: {
      description:
        'The Tellor oracle system is a fully decentralized community focused on securely placing data on-chain. The TRB token provides governance for Tellor.',
      reddit: 'https://github.com/tellor-io',
      twitter: 'https://twitter.com/wearetellor',
      website: 'https://tellor.io/',
    },
    primaryColor: '#23F08F',
    gradientColors: ['#23F08F', '#72FFBC'],
    gradientCoords: { x1: '-4.68%', y1: '1.381%', x2: '48.573%', y2: '30.414%' },
  },
  {
    name: 'trueusd',
    displayName: 'TrueUSD',
    decimals: 18,
    ticker: 'TUSD',
    addresses: {
      current: '0x0000000000085d4780B73119b644AE5ecd22b376',
      previous: ['0x8dd5fbCe2F6a956C3022bA3663759011Dd51e73E'],
    },
    info: {
      description:
        'TrueUSD is an Ethereum-based token designed as a stablecoin created by TrustToken. Smart contracts enable transparency over companies reserves, escrow accounts, etc. Each unit of TUSD is backed by USD banking reserves held by TrustToken, to ensure that 1 TUSD = 1 USD.',
      reddit: 'https://www.reddit.com/r/TrustToken/',
      twitter: 'https://twitter.com/TrustToken',
      website: 'https://www.trusttoken.com/trueusd/',
      telegram: 'https://t.me/joinchat/HihkMkTja1gIyBRM1J1_vg',
    },
    primaryColor: '#1A59FE',
    gradientColors: ['#1A59FE', '#5C89FF'],
    gradientCoords: { x1: '-4.68%', y1: '1.381%', x2: '48.573%', y2: '30.414%' },
  },
  {
    name: 'uma',
    displayName: 'UMA',
    decimals: 18,
    ticker: 'UMA',
    addresses: { current: '0x04Fa0d235C4abf4BcF4787aF4CF447DE572eF828' },
    info: {
      description:
        'UMA is a decentralized financial contracts platform built to enable universal access to financial markets.',
      twitter: 'https://twitter.com/UMAprotocol',
      website: 'https://umaproject.org/',
    },
    primaryColor: '#FF4A4A',
    gradientColors: ['#FF4A4A', '#CC3B3B'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '99.881%', y2: '99.881%' },
  },
  {
    name: 'uniswap',
    displayName: 'Uniswap',
    decimals: 18,
    ticker: 'UNI',
    addresses: { current: '0x1f9840a85d5aF5bf1D1762F925BDADdC4201F984' },
    info: {
      description:
        'UNI is the governance token of Uniswap, a decentralized protocol for automated liquidity provision on Ethereum.',
      reddit: 'https://www.reddit.com/r/UniSwap/',
      twitter: 'https://twitter.com/UniswapProtocol',
      website: 'https://uniswap.org/',
    },
    primaryColor: '#FF3495',
    gradientColors: ['#FC6CAB', '#FF007A'],
    gradientCoords: { x1: '0%', y1: '21.958%', x2: '214.397%', y2: '181.316%' },
  },
  {
    name: 'usdcoin',
    displayName: 'USDC',
    decimals: 6,
    ticker: 'USDC',
    addresses: { current: '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48' },
    info: {
      description:
        'USDC is a token designed as a stablecoin issued by Circle and Coinbase. Each unit of USDC is backed by a unit of US Dollar in audited bank accounts in order to ensure 1 USDC is always equal to 1 USD.',
      reddit: 'https://www.reddit.com/r/USDC/',
      twitter: 'https://twitter.com/centre_io',
      website: 'https://www.centre.io/usdc',
    },
    primaryColor: '#3E90E8',
    gradientColors: ['#3E90E8', '#2775CA'],
    gradientCoords: { x1: '102%', y1: '101%', x2: '0%', y2: '0%' },
  },
  {
    name: 'verasity',
    displayName: 'Verasity',
    decimals: 18,
    ticker: 'VRA',
    addresses: { current: '0xf411903cbc70a74d22900a5de66a2dda66507255' },
    info: {
      description:
        'Verasity offers creators a platform to share their videos and attract viewers. Advertisers can place ads in the content, providing earnings for both the creators and advertisers.',
      reddit: 'https://reddit.com/r/Verasity',
      twitter: 'https://twitter.com/verasitytech',
      website: 'https://www.verasity.io/',
      telegram: 'https://t.me/Verasity_Official',
    },
    primaryColor: '#CA2258',
    gradientColors: ['#CA2258', '#FE3E7C'],
    gradientCoords: { x1: '3%', y1: '4%', x2: '36%', y2: '35.5%' },
  },
  {
    name: 'viberate',
    displayName: 'Viberate',
    decimals: 18,
    ticker: 'VIB',
    addresses: { current: '0x2C974B2d0BA1716E644c1FC59982a89DDD2fF724' },
    info: {
      description:
        'Viberate is an Ethereum-based token used as a database for live music, where profiles are ranked according to their online popularity.',
      reddit: 'https://www.reddit.com/r/viberate',
      twitter: 'https://twitter.com/viberate',
      website: 'https://www.viberate.io/en/token',
      telegram: 'https://t.me/ViberateOfficial',
    },
    primaryColor: '#FF1F43',
    gradientColors: ['#BB3A4F', '#FF1F43'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '102%', y2: '101%' },
  },
  {
    name: 'voyager',
    displayName: 'Voyager',
    decimals: 8,
    ticker: 'VGXv2',
    displayTicker: 'VGX',
    addresses: { current: '0x3C4B6E6e1eA3D4863700D7F76b36B7f3D3f13E3d' },
    info: {
      description:
        'VGX 2.0 is the evolution of the initial VGX token, the native token of the Voyager platform. It is used to reward users within the Voyager ecosystem. It also generates interest when held in the Voyager app, offers cashback rewards, and other services exclusive to Voyager users.',
      reddit: 'https://www.reddit.com/r/Invest_Voyager/',
      twitter: 'https://twitter.com/investvoyager',
      website: 'https://www.investvoyager.com/',
      telegram: 'https://t.me/joinchat/H9SuYEmNirTJFHtMqtc70A',
    },
    primaryColor: '#9097FD',
    gradientColors: ['#3831AB', '#403B89'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '100.001%', y2: '100%' },
  },
  {
    name: 'wbtc',
    displayName: 'Wrapped Bitcoin',
    decimals: 8,
    ticker: 'WBTC',
    addresses: { current: '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599' },
    info: {
      description:
        'WBTC brings the power of Bitcoin together with the perks of the Ethereum network. Wrapped Bitcoin is backed 1:1 with Bitcoin.',
      twitter: 'https://twitter.com/WrappedBTC',
      website: 'https://wbtc.network/',
    },
    primaryColor: '#8958AB',
    gradientColors: ['#8958AB', '#3D2F52'],
    gradientCoords: { x1: '91.762%', y1: '69.532%', x2: '4.905%', y2: '24.223%' },
  },
  {
    name: 'weth',
    displayName: 'Wrapped Ether',
    decimals: 18,
    ticker: 'WETH',
    addresses: { current: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2' },
    info: {
      description:
        'WETH is the wrapped version of ETH that refers to the ERC-20 compatible version of Ether. Wrapping ETH does not affect its value, 1 ETH is always 1 WETH.',
      website: 'https://weth.io/',
    },
    primaryColor: '#FF58A2',
    gradientColors: ['#EC9CC6', '#ED1E79'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '20%', y2: '20%' },
  },
  {
    name: 'wnxm_ethereum_52ead9a6',
    displayName: 'Wrapped NXM',
    decimals: 18,
    ticker: 'WNXMethereum52EAD9A6',
    displayTicker: 'WNXM',
    addresses: { current: '0x0d438F3b5175Bebc262bF23753C1E53d03432bDE' },
    info: {
      description:
        'The WNXM token is a wrapped version of NXM and represents ownership of the insurance protocol Nexus Mutual. WNXM offers holders governance, risk and claims assessments, and more.',
      twitter: 'https://twitter.com/NexusMutual',
      website: 'https://nexusmutual.io/',
    },
    primaryColor: '#1EAB89',
    gradientColors: ['#1EAB89', '#3ADFB7'],
    gradientCoords: { x1: '3%', y1: '8.49%', x2: '41.043%', y2: '26.73%' },
  },
  {
    name: 'woo_ethereum_0b749579',
    displayName: 'Woo Network',
    decimals: 18,
    ticker: 'WOOethereum0B749579',
    displayTicker: 'WOO',
    addresses: { current: '0x4691937a7508860F876c9c0a2a617E7d9E945D4B' },
    info: {
      description:
        'The WOO token is used for staking, management, governance, and more in WOO Network, a trading platform that brings CeFi and DeFi together to offer better liquidity and low or zero fees.',
      reddit: 'https://reddit.com/r/WOO_X',
      twitter: 'https://twitter.com/WOOnetwork',
      website: 'https://woo.org',
    },
    primaryColor: '#77E292',
    gradientColors: ['#39E6D7', '#40FF80'],
    gradientCoords: { x1: '0%', y1: '0%', x2: '100%', y2: '100%' },
  },
  {
    name: 'yfi',
    displayName: 'Yearn Finance',
    decimals: 18,
    ticker: 'YFI',
    addresses: { current: '0x0bc529c00C6401aEF6D220BE8C6Ea1667F6Ad93e' },
    info: {
      description:
        'YFI is the governance token of Yearn.Finance, a decentralized platform allowing users to easily move their assets in and out of different liquidity pools.',
      twitter: 'https://twitter.com/iearnfinance',
      website: 'https://yearn.finance/',
      telegram: 'https://t.me/yearnfinance',
    },
    primaryColor: '#0076FC',
    gradientColors: ['#0076FC', '#0052B0'],
    gradientCoords: { x1: '0%', y1: '21.958%', x2: '99.12%', y2: '78.676%' },
  },
  {
    name: 'ygg',
    displayName: 'Yield Guild Games',
    decimals: 18,
    ticker: 'YGG',
    addresses: { current: '0x25f8087EAD173b73D6e8B84329989A8eEA16CF73' },
    info: {
      description:
        'Yield Guild Games is a DAO of gamers and investors building an expansive virtual economy powered by play-to-earn gaming and NFTs. The YGG ecosystem includes Axie Infinity, Illuvium, Start Atlas, and many other games.',
      twitter: 'https://twitter.com/yieldguild',
      website: 'https://yieldguild.io/',
    },
    primaryColor: '#518BEF',
    gradientColors: ['#2856A6', '#518BEF'],
    gradientCoords: { x1: '12.8%', y1: '14%', x2: '27.91%', y2: '25.4%' },
  },
  {
    name: 'zerox',
    displayName: '0x',
    decimals: 18,
    ticker: 'ZRX',
    addresses: { current: '0xE41d2489571d322189246DaFA5ebDe1F4699F498' },
    info: {
      description:
        '0x wants to become the exchange layer of the crypto economy by enabling the decentralized exchange of Ethereum-based assets like ICO tokens, digital art, in-game items, loans, and much more, wallet to wallet, instead of through centralized exchanges.',
      reddit: 'https://www.reddit.com/r/0xProject/',
      twitter: 'https://twitter.com/0xproject',
      website: 'https://www.0xproject.com/',
    },
    primaryColor: '#C8C8C8',
    gradientColors: ['#C8C8C8', '#979797'],
    gradientCoords: { x1: '11.224%', y1: '-66.682%', x2: '141.81%', y2: '91.487%' },
  },
]
